// extracted by mini-css-extract-plugin
export default {"home":"Groups_home__SJxAX","card":"Groups_card__suFNh","new_card":"Groups_new_card__00aLB","submitButton":"Groups_submitButton__rDTDt"};